import { Close } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { startContentAnalysis } from "../../../pages/postEditor/seoAnalyzer/content";
import { setActivePanel } from "../../../redux/slices/panelSlice";
import { dispatch } from "../../../redux/store";
import { LaunchAnalysisBtn } from "../Others";

const Content = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state?.auth.userInfo);

  const formikProps = useFormikContext();
  const [analysis, setAnalysis] = useState();
  const seoInput =
    formikProps.values.seo_request === ""
      ? "REQUEST"
      : formikProps.values.seo_request;

  const competitorResults = useSelector(
    (state) => state.competitorAnalysis.data?.data
  );

  useEffect(() => {
    const analyze = startContentAnalysis(formikProps, competitorResults);

    setAnalysis(analyze);
  }, [formikProps.values]);
  const handleClose = () => {
    dispatch(setActivePanel(null));
  };

  return (
    <Box
      sx={{
        position: "fixed",
        overflow: "auto",
        height: { md: "100vh", xs: "100%" },
        width: { md: "auto", xs: "100%" },
        display: "flex",
        flexDirection: { md: "row", xs: "column" },
        justifyContent: "end",
        mt: { md: "48px !important", xs: "unset !important" },
        right: 0,
        top: 0,
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#303539",
          height: "100vh",
          width: { lg: "500px", md: "350px", xs: "100%" },
          color: "white",
          pb: 5,
          //overflow: 'auto',
        }}
        className="overflow-y-scroll"
      >
        <Box
          sx={{
            backgroundColor: "#3e6590",
            padding: 2,
            position: "relative",
          }}
        >
          <Box
            onClick={handleClose}
            sx={{
              position: "absolute",
              cursor: "pointer",
              right: 0,
              top: 0,
              p: 2,
            }}
          >
            <Close sx={{ color: "white", fontSize: 32 }} />
          </Box>
          <h1 className="text-2xl mb-2">{t("Content", "Contenu")}</h1>

          <p className="text-xs mb-2">
            {t(
              "tutorial-text-content",
              "La balise H1 est un important facteur du référencement de votre page, autant par l’importance qu’elle a pour Google que pour vos lecteurs. Suivez nos indications, générez des idées et inspirez-vous de la la concurrence !"
            )}
          </p>
          {/* <p className="text-xs">
            {t('For-more-info:', "Pour plus d'infos :")}{' '}
            <span>
              <a className="text-blue-500 underline cursor-pointer">
                {t(
                  'content-optimization-guide',
                  'Rédaction SEO : le Guide Complet 2024'
                )}
              </a>
            </span>
          </p> */}
        </Box>

        <LaunchAnalysisBtn
          userInfo={userInfo}
          formikProps={formikProps}
          disabled={true}
          analysis={analysis}
          type={"content"}
        />
      </Box>
    </Box>
  );
};

export default Content;
